import { prefix } from "../../design-tokens/meta";
import { actions, events } from "../../js/state-machine";

export const componentName = "SideNavGroup";

export const sideNavGroupClasses = {
    collapse: `${prefix}collapse`,
    groupSelected: `${prefix}side-nav__group--selected`,
};

export const defaultProps = {
    expand: false,
};

export const views = {
    trigger: {
        expanded: {
            attrs: { "aria-expanded": "true" },
        },
        collapsed: {
            attrs: { "aria-expanded": "false" },
        },
    },
    target: {
        expanded: {
            classList: [`!${sideNavGroupClasses.collapse}`],
        },
        collapsed: {
            classList: [`${sideNavGroupClasses.collapse}`],
        },
    },
    selected: {
        classList: [sideNavGroupClasses.collapse, sideNavGroupClasses.groupSelected],
    },
    default: {
        classList: [`!${sideNavGroupClasses.collapse}`, `!${sideNavGroupClasses.groupSelected}`],
    },
};

// Actions mapped into event values to be used as callback for the action.
export const eventMap = {
    [actions.expand().type]: events.expanded(componentName),
    [actions.collapse().type]: events.collapsed(componentName),
};
